import React from "react";
import PolicyLayout from "./PolicyLayout";

const sections = [
  <><b>Alpaago</b> aims to deliver your orders promptly and efficiently. Products are typically dispatched within <b>2–4 business days</b> of order confirmation.</>,
  <>Delivery times may vary depending on your location and courier availability. You will receive tracking details once your order ships.</>,
  <>In case of delays or failed deliveries due to incorrect addresses, <b>Alpaago</b> will not be liable for replacement or refund.</>,
  <>For delivery support, reach out to <b>contact@alpaago.com</b> or call <b>+91 73974 60454</b>.</>,
];

export default function DeliveryPolicy() {
  return <PolicyLayout title="Delivery Policy" sections={sections} />;
}
